import { useState, useEffect } from 'react';
import { ImageOff } from 'lucide-react';

interface Props {
  src?: string;
  alt?: string;
  className?: string;
}

/**
 * 진단 상품 썸네일. URL 이 비어있거나 onError 로드 실패 시
 * 회색 플레이스홀더(아이콘) 를 표시해 broken-image UI 를 방지.
 */
const GoodsImage = ({ src, alt = '', className = '' }: Props) => {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  const showFallback = !src || errored;

  if (showFallback) {
    return (
      <div
        className={`flex items-center justify-center bg-gr-100 text-gr-400 ${className}`}
        aria-label={alt || '상품 이미지 없음'}
      >
        <ImageOff className="h-[24px] w-[24px]" strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      className={className}
    />
  );
};

export default GoodsImage;
